/*!
 * blc-cart-preview.js v3
 * Magtion Bird Life List — cart page custom preview renderer.
 * v3: poster-faithful typography — Playfair Display title (0.12em tracking),
 * Crimson Text italic subtitle/footer, bordered bird cells with names,
 * matching the builder's live poster exactly. 320x480 canvas.
 */
(function () {
  'use strict';
  if (window.__blcCartPreview) return;
  window.__blcCartPreview = true;

  var CATALOG_URL = 'https://cdn.shopify.com/s/files/1/0931/5808/0798/files/bird-catalog.json';
  var CATALOG_CACHE_KEY = 'blc-bird-catalog-v1';
  var RENDER_CACHE_KEY = 'blc-render-cache-v3';
  var TYPE_BY_VARIANT = {
    '59735354409246': 'canvas', '59735354573086': 'frame',
    '59735354442014': 'canvas', '59735354605854': 'frame',
    '59735354474782': 'canvas', '59735354638622': 'frame',
    '59735354507550': 'canvas', '59735354671390': 'frame',
    '59735354540318': 'canvas', '59735354704158': 'frame'
  };

  // Poster palette & type (from the builder's .blc-poster-* styles)
  var C = {
    bg: '#faf8f5', text: '#17231d', sub: '#526159', line: '#e2e8e3',
    cellBg: '#ffffff', name: '#29372f', footer: '#66746c', frame: '#1a1a1a'
  };

  var INJECTED_CSS = [
    "@import url('https://fonts.googleapis.com/css2?family=Crimson+Text:ital,wght@0,600;1,600&family=Playfair+Display:wght@500;600&display=swap');",
    '.blc-custom-row .cart-item__media{width:150px}',
    '.blc-custom-row .cart-item__image-container{padding:8px;background:#faf8f5;border:1px solid #e2e8e3;border-radius:6px;box-shadow:0 2px 10px rgba(60,40,20,.10)}',
    '.blc-custom-row .cart-item__image{width:100%!important;height:auto!important;display:block;border-radius:2px}',
    '@media(min-width:750px){',
    '  .blc-custom-row .cart-item__media{width:220px}',
    '}',
    '@media(max-width:749px){',
    '  .blc-custom-row .cart-item__media{width:128px}',
    '}'
  ].join('\n');

  function injectCss() {
    try {
      var s = document.createElement('style');
      s.id = 'blc-cart-preview-css';
      s.textContent = INJECTED_CSS;
      document.head.appendChild(s);
    } catch (e) { /* non-fatal */ }
  }

  function getStore(key) { try { return JSON.parse(localStorage.getItem(key)); } catch (e) { return null; } }
  function setStore(key, val) { try { localStorage.setItem(key, JSON.stringify(val)); } catch (e) { /* quota */ } }
  function getSession(key) { try { return JSON.parse(sessionStorage.getItem(key)); } catch (e) { return null; } }
  function setSession(key, val) { try { sessionStorage.setItem(key, JSON.stringify(val)); } catch (e) { /* quota */ } }

  var catalogPromise = null;
  function getCatalog() {
    if (catalogPromise) return catalogPromise;
    var cached = getStore(CATALOG_CACHE_KEY);
    if (cached && cached.v === 1) {
      catalogPromise = Promise.resolve(cached.map);
      return catalogPromise;
    }
    catalogPromise = fetch(CATALOG_URL, { credentials: 'omit' }).then(function (r) {
      if (!r.ok) throw new Error('catalog HTTP ' + r.status);
      return r.json();
    }).then(function (cat) {
      var map = {};
      (cat.birds || []).forEach(function (b) { map[b.c] = { code: b.c, name: b.n, img: b.u }; });
      setStore(CATALOG_CACHE_KEY, { v: 1, map: map });
      return map;
    }).catch(function (e) { catalogPromise = null; throw e; });
    return catalogPromise;
  }

  var fontsPromise = null;
  function ensureFonts() {
    if (fontsPromise) return fontsPromise;
    fontsPromise = new Promise(function (resolve) {
      var done = false;
      function fin() { if (!done) { done = true; resolve(); } }
      try {
        if (!document.fonts || !document.fonts.load) { fin(); return; }
        Promise.all([
          document.fonts.load('500 20px "Playfair Display"'),
          document.fonts.load('italic 600 14px "Crimson Text"')
        ]).then(fin, fin);
        setTimeout(fin, 2500); // never block the swap for long
      } catch (e) { fin(); }
    });
    return fontsPromise;
  }

  // ---- canvas text helpers ----
  function drawSpaced(ctx, text, x, y, tracking) {
    // manual letter-spacing for reliable cross-browser rendering
    var total = 0;
    for (var i = 0; i < text.length; i++) total += ctx.measureText(text[i]).width;
    total += tracking * (text.length - 1);
    var cx = x - total / 2;
    for (var j = 0; j < text.length; j++) {
      ctx.fillText(text[j], cx, y);
      cx += ctx.measureText(text[j]).width + tracking;
    }
  }

  function fitSize(ctx, text, start, min, maxWidth) {
    var size = start;
    while (size > min && ctx.measureText(text).width > maxWidth) size -= 1;
    return size;
  }

  function drawWrappedName(ctx, text, cx, cy, maxWidth, maxLines) {
    var words = String(text).split(' ');
    var lines = [];
    var cur = '';
    for (var i = 0; i < words.length; i++) {
      var trial = cur ? cur + ' ' + words[i] : words[i];
      if (ctx.measureText(trial).width > maxWidth && cur) {
        lines.push(cur);
        cur = words[i];
        if (lines.length >= maxLines) break;
      } else {
        cur = trial;
      }
    }
    if (lines.length < maxLines && cur) lines.push(cur);
    var used = lines.slice(0, maxLines);
    if (words.join(' ') !== used.join(' ')) {
      var last = used[used.length - 1] || '';
      while (last.length > 1 && ctx.measureText(last + '…').width > maxWidth) last = last.slice(0, -1);
      used[used.length - 1] = last + '…';
    }
    // lineH must be derived from measureText (actualBoundingBox* is only set after fillText)
    var m = ctx.measureText(text);
    var lineH = (m.actualBoundingBoxAscent + m.actualBoundingBoxDescent) || parseFloat(ctx.font) || 14;
    var startY = cy - ((used.length - 1) * lineH) / 2;
    used.forEach(function (ln, k) { ctx.fillText(ln, cx, startY + k * lineH); });
    return used.length;
  }

  // ---- poster-faithful render (320x480, 2:3 like the builder poster) ----
  function renderThumb(birds, title, subtitle, layout, hasFrame) {
    return ensureFonts().then(function () {
      return new Promise(function (resolve) {
        var W = 320, H = 480;
        var canvas = document.createElement('canvas');
        canvas.width = W; canvas.height = H;
        var ctx = canvas.getContext('2d');
        var pad = hasFrame ? 20 : 0;
        var w = W - pad * 2, h = H - pad * 2;
        if (hasFrame) {
          ctx.fillStyle = C.frame; ctx.fillRect(0, 0, W, H);
        }
        ctx.fillStyle = C.bg; ctx.fillRect(pad, pad, w, h);
        if (hasFrame) { ctx.save(); ctx.beginPath(); ctx.rect(pad, pad, w, h); ctx.clip(); }

        var maxBirds = layout === '3x3' ? 9 : 4;
        var cols = layout === '3x3' ? 3 : 2;
        var padX = 18, padTop = 24;
        var usable = w - padX * 2;

        // header: title + subtitle + divider
        ctx.textAlign = 'center';
        ctx.fillStyle = C.text;
        ctx.font = '500 20px "Playfair Display", Georgia, serif';
        var titleSize = fitSize(ctx, title.toUpperCase(), 20, 14, usable);
        ctx.font = '500 ' + titleSize + 'px "Playfair Display", Georgia, serif';
        drawSpaced(ctx, title.toUpperCase(), pad + w / 2, pad + padTop + titleSize, Math.max(2, titleSize * 0.12));
        var subY = pad + padTop + titleSize + 14;
        ctx.font = 'italic 600 14px "Crimson Text", Georgia, serif';
        ctx.fillStyle = C.sub;
        var subText = subtitle || '';
        if (subText) {
          var subSize = fitSize(ctx, subText, 14, 10, usable);
          ctx.font = 'italic 600 ' + subSize + 'px "Crimson Text", Georgia, serif';
          ctx.fillText(subText, pad + w / 2, subY);
        }
        var divY = subY + 8;
        ctx.strokeStyle = C.line; ctx.lineWidth = 1;
        ctx.beginPath(); ctx.moveTo(pad + padX, divY); ctx.lineTo(pad + w - padX, divY); ctx.stroke();

        // footer
        var footerY = pad + h - 10;
        ctx.font = 'italic 600 12px "Crimson Text", Georgia, serif';
        ctx.fillStyle = C.footer;
        ctx.fillText('My Bird List / 2026', pad + w / 2, footerY);

        // bird grid
        var gridTop = divY + 14;
        var gridBottom = footerY - 14;
        var gap = 10;
        var gridW = usable, gridH = gridBottom - gridTop;
        var cellW = (gridW - gap * (cols - 1)) / cols;
        var rows = maxBirds / cols;
        var cellH = (gridH - gap * (rows - 1)) / rows;
        var total = birds.length;
        if (total === 0) { if (hasFrame) ctx.restore(); resolve(canvas.toDataURL('image/jpeg', 0.55)); return; }

        var loaded = 0;
        birds.forEach(function (bird, i) {
          var r = Math.floor(i / cols), c = i % cols;
          var cx = pad + padX + c * (cellW + gap);
          var cy = gridTop + r * (cellH + gap);
          // cell card
          ctx.fillStyle = C.cellBg;
          ctx.strokeStyle = C.line; ctx.lineWidth = 1;
          roundRect(ctx, cx, cy, cellW, cellH, 6);
          ctx.fill(); ctx.stroke();
          // image area: max 68% of cell height (poster: max-height:68%)
          var nameH = 18;
          var imgBoxH = cellH - nameH - 6;
          var imgW = cellW - 8;
          var img = new Image(); img.crossOrigin = 'anonymous';
          img.onload = function () {
            var ratio = Math.min(imgW / img.width, imgBoxH / img.height);
            var dw = img.width * ratio, dh = img.height * ratio;
            ctx.save();
            roundRect(ctx, cx + 1, cy + 1, cellW - 2, cellH - 2, 6);
            ctx.clip();
            ctx.drawImage(img, cx + (cellW - dw) / 2, cy + (imgBoxH - dh) / 2 + 2, dw, dh);
            ctx.restore();
            // name
            ctx.font = '600 12px "Crimson Text", Georgia, serif';
            ctx.fillStyle = C.name;
            var nameSize = fitSize(ctx, bird.name, 12, 8, cellW - 6);
            ctx.font = '600 ' + nameSize + 'px "Crimson Text", Georgia, serif';
            drawWrappedName(ctx, bird.name, cx + cellW / 2, cy + cellH - 6, cellW - 6, 2);
            loaded++; if (loaded === total) { if (hasFrame) ctx.restore(); resolve(canvas.toDataURL('image/jpeg', 0.55)); }
          };
          img.onerror = function () {
            ctx.fillStyle = '#ccc'; ctx.font = '16px sans-serif'; ctx.textAlign = 'center';
            ctx.fillText('?', cx + cellW / 2, cy + cellH / 2);
            loaded++; if (loaded === total) { if (hasFrame) ctx.restore(); resolve(canvas.toDataURL('image/jpeg', 0.55)); }
          };
          img.src = bird.img;
        });
      });
    });
  }

  function roundRect(ctx, x, y, w, h, r) {
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + w, y, x + w, y + h, r);
    ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r);
    ctx.arcTo(x, y, x + w, y, r);
    ctx.closePath();
  }

  function processCart(items) {
    var renderCache = getSession(RENDER_CACHE_KEY) || {};
    var jobs = [];
    items.forEach(function (item, idx) {
      var props = item.properties || {};
      var codes = (props['_Bird Codes'] || '').split(',').filter(Boolean);
      if (!codes.length) return;
      var type = TYPE_BY_VARIANT[item.variant_id] || 'canvas';
      var job = {
        key: item.key, idx: idx, codes: codes,
        title: props.Title || '', subtitle: props.Subtitle || '',
        layout: props['_Layout'] === '3x3' ? '3x3' : '2x2',
        frame: type === 'frame'
      };
      if (renderCache[job.key]) { applyToRow(job.idx, renderCache[job.key]); return; }
      jobs.push(job);
    });
    if (!jobs.length) return;
    getCatalog().then(function (byCode) {
      jobs.forEach(function (job) {
        var birds = job.codes.map(function (c) { return byCode[c]; }).filter(Boolean);
        if (!birds.length) return;
        renderThumb(birds, job.title, job.subtitle, job.layout, job.frame).then(function (dataUrl) {
          renderCache[job.key] = dataUrl;
          setSession(RENDER_CACHE_KEY, renderCache);
          applyToRow(job.idx, dataUrl);
        });
      });
    }).catch(function (e) {
      console.error('[blc-cart-preview] catalog failed, keeping default images:', e);
    });
  }

  function applyToRow(idx, dataUrl) {
    var row = document.getElementById('CartItem-' + (idx + 1));
    if (!row) return;
    row.classList.add('blc-custom-row');
    var img = row.querySelector('img.cart-item__image');
    if (img) img.src = dataUrl;
  }

  function run() {
    injectCss();
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.items && cart.items.length) processCart(cart.items);
      })
      .catch(function () { /* non-fatal */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
